import React from 'react';
import PublicPageLayout from '../PublicPageLayout';
import Help from '../../../../../pages/post-auth/home/help/help.component';

const HelpPage = ({ history }) => (
  <PublicPageLayout history={history}>
    <Help isPublic={true} />
  </PublicPageLayout>
);

export default HelpPage;

